/** Service Desk console: Service settings, bahagi A - ang menu, General (prefix, mga salita), mga Uri ng ticket at ang type editor, mga Field, mga Status (SD-S1-47). */
export const serviceSettingsA = {
  nav: {
    label: "Mga seksyon ng Service settings",
    locked: "Wala sa plano mo",
    general: "General at numbering",
    types: "Mga uri ng ticket",
    fields: "Mga field",
    statuses: "Mga status",
  },
  soon: {
    title: "Magbubukas ang seksyong ito sa susunod na release",
    body: "Tama ang address, hindi pa lang tapos ang screen. Ligtas ang mga setting mo at walang kulang sa panig mo.",
    back: "Bumalik sa General",
  },
  locked: {
    title: "Kasama ang {{section}} mula sa planong {{plan}}",
    body: "Mananatili ang mga kasalukuyang setting at ticket mo. Mag-upgrade para mabago ang seksyong ito.",
  },
  loading: "Naglo-load",
  labelPair: {
    en: "{{legend}} (English)",
    fil: "{{legend}} (Filipino)",
    filHint: "Opsyonal. Babalik sa English kapag walang laman.",
  },
  sort: {
    up: "Ilipat pataas ang {{name}}",
    down: "Ilipat pababa ang {{name}}",
    moved: "Inilipat ang {{name}} sa posisyon {{position}} sa {{total}}",
  },
  groups: {
    problems: "Mga problema",
    requests: "Mga kahilingan",
    orders: "Mga order at billing",
    feedback: "Feedback",
  },
  numbering: {
    title: "Mga numero ng ticket",
    intro: "Bawat ticket ay may numerong binubuo ng prefix na ito at ng counter, tulad ng halimbawa sa ibaba. Isang beses mo lang maitatakda ang prefix, bago pa magkaroon ng unang ticket.",
    lockedIntro: "Naka-lock ang prefix: isang beses lang itong maitatakda, bago magkaroon ng unang ticket, at nangyari na iyon.",
    lockedBadge: "Naka-lock",
    label: "Prefix ng numero ng ticket",
    hint: "2 hanggang 5 malalaking letra. Ganito ang numero ng ticket: {{example}}.",
    invalid: "Gumamit ng 2 hanggang 5 letra, tulad ng KHA.",
    save: "I-save ang prefix",
    saved: "Naitakda ang prefix ng ticket sa {{prefix}}.",
    confirmTitle: "Gamitin ang {{prefix}} sa lahat ng numero ng ticket?",
    confirmBody: "Magbabago ang prefix mula {{from}} patungong {{to}} at hindi na ito mababago ulit. Mananatili ang numero ng mga ticket na nagawa na.",
    confirm: "Itakda ang prefix",
  },
  vocabulary: {
    title: "Mga salitang nakikita ng mga customer mo",
    intro: "Palitan ang mga termino ng industriya mo sa console, sa portal at sa mga e-mail. Iwanang walang laman para manatili ang karaniwang salita. Maaaring may naitakda na ang isang template pack.",
    en: "English",
    fil: "Filipino",
    save: "I-save ang mga salita",
    discard: "Itapon ang mga pagbabago",
    saved: "Na-save ang mga salita.",
    terms: {
      organisation: "Organisasyon",
      contact: "Contact",
      asset: "Asset",
      project: "Proyekto",
      project_plural: "Proyekto (maramihan)",
      stage: "Yugto",
      stage_plural: "Yugto (maramihan)",
      open_item: "Bukas na item",
      visit: "Pagbisita",
    },
    defaults: {
      organisation: "Organisasyon",
      contact: "Contact",
      asset: "Asset",
      project: "Proyekto",
      project_plural: "Mga Installation",
      stage: "Yugto",
      stage_plural: "Mga yugto",
      open_item: "Bukas na item",
      visit: "Pagbisita",
    },
  },
  errors: {
    planLimit: {
      types: "Naabot na ang limit ng plano mo sa custom na uri ng ticket. I-archive ang hindi mo na ginagamit, o mag-upgrade.",
      fields: "Naabot na ang limit ng plano mo sa custom na field. Alisin ang hindi mo na ginagamit, o mag-upgrade.",
      statuses: "Naabot na ang limit ng plano mo sa custom na status. Burahin ang hindi mo na ginagamit, o mag-upgrade.",
    },
    typeInUse_one: "{{count}} ticket ang gumagamit sa uring ito. I-archive ito sa halip na burahin.",
    typeInUse_other: "{{count}} ticket ang gumagamit sa uring ito. I-archive ito sa halip na burahin.",
    statusInUse_one: "{{count}} ticket ang nasa status na ito. Pumili ng kapalit na status na kapareho ng kategorya.",
    statusInUse_other: "{{count}} ticket ang nasa status na ito. Pumili ng kapalit na status na kapareho ng kategorya.",
    codeInUse: "May mga ticket na nagtatapos sa code na ito. I-deactivate ito sa halip na burahin.",
    systemRecord: "Built-in ito: palitan ang label o i-off sa halip na burahin.",
    prefixLocked: "Isang beses lang mapapalitan ang prefix ng numero ng ticket, bago magkaroon ng unang ticket. Naka-lock na ito ngayon.",
    fieldInUse: "May uri ng ticket o live na workflow na gumagamit pa rin sa field na ito. Alisin muna ito roon.",
    fieldHasAnswers_one: "{{count}} record ang may sagot sa field na ito. Alisin ito sa mga uri ng ticket sa halip na burahin, para manatiling nababasa ang mga sagot.",
    fieldHasAnswers_other: "{{count}} record ang may sagot sa field na ito. Alisin ito sa mga uri ng ticket sa halip na burahin, para manatiling nababasa ang mga sagot.",
    fieldDependents: "May iba pang field ng uring ito na nakadepende rito. Baguhin muna ang mga field na iyon.",
  },
  flags: {
    ai: "Puwedeng punan ng AI",
    pii: "Personal na data",
    hiddenAi: "Hindi kailanman ipinapadala sa AI",
    clientRequired: "Kailangan ng kliyente",
    staffCreate: "Staff: sa paggawa",
    staffResolve: "Staff: bago i-resolve",
    client: {
      hidden: "Nakatago sa mga kliyente",
      edits: "Nag-e-edit ang kliyente",
      sees: "Nakikita ng kliyente",
    },
  },
  types: {
    title: "Mga uri ng ticket",
    new: "Bagong custom na uri",
    builtIn: "Built-in",
    custom: "Custom",
    archived: "Naka-archive",
    planLocked: "Wala sa plano mo",
    category: { customer: "Customer", back_office: "Back office", tracker: "Tracker" },
    categoryHint: {
      customer: "Nakikita at mapipili ng mga kliyente.",
      back_office: "Panloob: hindi kailanman nakikita ng mga kliyente.",
      tracker: "Iniuugnay ang maraming ticket ng customer sa iisang sanhi.",
    },
    asset: { no: "Hindi hinihingi ang kagamitan", optional: "Opsyonal ang kagamitan", required: "Kailangan ang kagamitan" },
    group: "Grupo sa portal",
    equipment: "Kagamitan",
    priority: "Default na priyoridad",
    team: "Default na team",
    noTeam: "Walang default na team",
    counts: "Mga ticket: {{tickets}} · Mga field: {{fields}}",
    pick: "Mapipili ng kliyente",
    pickAria: "Mapipili ng kliyente ang {{name}}",
    pickOn: "Mapipili na ng mga kliyente ang {{name}}.",
    pickOff: "Nakatago sa mga kliyente ang {{name}}.",
    notShown: "Hindi ipinapakita sa mga kliyente",
    edit: "I-edit",
    editAria: "I-edit ang {{name}}",
    archive: "I-archive",
    archiveAria: "I-archive ang {{name}}",
    restore: "Ibalik",
    restoreAria: "Ibalik ang {{name}}",
    archiveTitle: "I-archive ang uring ito?",
    archiveBody_one: "{{count}} ticket ang gumagamit sa {{name}}. Mananatili ito kapag in-archive; hihinto lang ang mga kliyente at ang assistant sa pag-aalok ng uring ito.",
    archiveBody_other: "{{count}} ticket ang gumagamit sa {{name}}. Mananatili ang mga ito kapag in-archive; hihinto lang ang mga kliyente at ang assistant sa pag-aalok ng uring ito.",
    archiveConfirm: "I-archive ang uri",
    archivedToast: "Na-archive ang {{name}}.",
    restoredToast: "Naibalik ang {{name}}.",
    emptyTitle: "Wala pang uri ng ticket",
    emptyBody: "Ang mga uri ng ticket ang nagpapasya sa form na ginagamit sa paghiling. Mag-apply ng template pack sa General, o gumawa ng sarili mo.",
    footPlain: "Mga custom na uri: {{count}}.",
    footLimited: "Mga custom na uri: {{count}} sa {{limit}} sa planong {{plan}}.",
    footUnlimited: "Mga custom na uri: {{count}}. Walang limit sa planong {{plan}}.",
    footNote: "Mananatili ang mga kasalukuyang ticket ng mga naka-archive na uri.",
  },
  typeNew: {
    title: "Bagong custom na uri",
    description: "Pangalanan ito at sabihin kung sino ang makakakita. Idaragdag mo ang mga field, kondisyon at gabay sa intake sa editor pagkatapos.",
    name: "Pangalan",
    category: "Kategorya",
    group: "Grupo sa portal",
    groupHint: "Kung saan ito makikita ng mga kliyente sa portal at sa widget.",
    create: "Gumawa ng uri",
    created: "Nagawa ang {{name}}. Idagdag na ang mga field nito.",
    errors: {
      nameRequired: "Pangalanan ang uri.",
      nameShort: "Gumamit ng hindi bababa sa {{min}} karakter.",
      nameLong: "Gumamit ng {{max}} karakter o mas kaunti.",
      nameTaken: "May uri nang may ganitong pangalan.",
    },
  },
  editor: {
    back: "Service settings",
    subtitleBuiltIn_one: "Built-in na uri · {{audience}} · {{count}} ticket ang gumagamit.",
    subtitleBuiltIn_other: "Built-in na uri · {{audience}} · {{count}} ticket ang gumagamit.",
    subtitleCustom_one: "Custom na uri · {{audience}} · {{count}} ticket ang gumagamit.",
    subtitleCustom_other: "Custom na uri · {{audience}} · {{count}} ticket ang gumagamit.",
    audienceClients: "nakikita ng mga kliyente",
    audienceInternal: "panloob",
    archivedBanner: "Naka-archive ang uring ito. Mananatili ito sa mga kasalukuyang ticket; hindi na ito iaalok ng mga kliyente at ng assistant.",
    duplicate: "I-duplicate",
    duplicated: "Nagawa ang kopya: {{name}}.",
    duplicatePartial_one: "Nagawa ang kopya, pero {{count}} field ang hindi nakopya. Idagdag ito nang mano-mano.",
    duplicatePartial_other: "Nagawa ang kopya, pero {{count}} field ang hindi nakopya. Idagdag ang mga ito nang mano-mano.",
    delete: "Burahin",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Aalisin nito ang uri at ang listahan ng mga field nito. Hindi mabubura ang uring ginagamit ng mga ticket: i-archive na lang ito.",
    deleteConfirm: "Burahin ang uri",
    deleted: "Nabura ang {{name}}.",
    details: "Pangalan at pag-uugali",
    name: "Pangalan",
    description: "Paglalarawan",
    icon: "Icon",
    iconHint: "Ipinapakita sa tabi ng pangalan sa widget at sa portal.",
    iconDefault: "Default na icon",
    group: "Grupo sa portal",
    groupHint: "Kung saan ito makikita ng mga kliyente.",
    groupNone: "Walang grupo",
    category: "Kategorya",
    categoryHint: "Hindi na nagbabago ang kategorya pagkatapos gawin.",
    priority: "Default na priyoridad",
    team: "Default na team",
    teamNone: "Walang default na team",
    teamUnavailable: "Hindi mo mababasa ang mga team, kaya mananatili ang team.",
    sla: "SLA policy",
    slaInherit: "Sundin ang kontrata o ang default ng workspace",
    slaHint: "Ikabit sa uring ito ang isa sa mga ticket SLA policy mo.",
    slaUnavailable: "Hindi mo mababasa ang mga SLA policy, kaya mananatili ito.",
    equipment: "Kagamitan",
    clientSelectable: "Mapipili ng mga kliyente ang uring ito",
    clientSelectableHint: "Mapipili rin ito ng assistant. Hindi kailanman iniaalok ang mga uring back-office.",
    planLockedHint: "Wala sa plano mo ang kailangan ng uring ito, kaya hindi pa ito mapipili ng mga kliyente.",
    verified: "Kailangang beripikado muna ang kliyente",
    verifiedHint: "Hindi makakagawa ng ganitong uri ang bisitang hindi beripikado.",
    resolutionCode: "Pumipili ng resolution code ang staff",
    resolutionCodeHint: "Kailangan kapag nilutas ang ticket ng uring ito.",
    site: "Hingin ang site",
    siteHint: "Tungkol sa isang site o installation ang mga ticket ng uring ito.",
    order: "Hingin ang order",
    orderHint: "Tungkol sa isang order ang mga ticket ng uring ito.",
    visit: "Maaaring kailangan ng pagbisita",
    visitHint: "Makakapag-iskedyul ang staff ng field visit mula sa mga ticket na ito.",
    yes: "Oo",
    no: "Hindi",
    fields: "Mga field",
    fieldCount: "{{count}} sa {{max}}",
    addField: "Magdagdag ng field",
    addFirstField: "Idagdag ang unang field",
    fieldsEmptyTitle: "Wala pang custom na field",
    fieldsEmptyBody: "Pamagat at paglalarawan lang ang hinihingi ng uring ito. Magdagdag ng mga field para makuha ng staff ang mga detalyeng kailangan at mapunan ng assistant mula sa chat.",
    fieldsOrderLabel: "Mga field ayon sa pagkakasunod na nakikita ng mga kliyente",
    fieldsFull: "Hanggang {{max}} field ang kaya ng isang uri.",
    systemFields: "May mga system field din ang bawat ticket: numero, uri, pamagat, paglalarawan, status, priyoridad, humihiling, organisasyon, site, mga asset, team, nakatalaga, mga tag at channel.",
    editField: "I-edit",
    editFieldAria: "I-edit ang {{name}}",
    removeFieldAria: "Alisin ang {{name}} sa uring ito",
    removeTitle: "Alisin ang {{name}} sa uring ito?",
    removeBody: "Mananatili ang mga value na nasa mga ticket na, nakatago lang. Mananatiling magagamit ang field sa ibang uri.",
    removeConfirm: "Alisin ang field",
    fieldRemoved: "Naalis ang {{name}} sa uring ito.",
    onlyIf: "Kung {{field}} ay {{values}} lang",
    guidance: "Gabay sa intake para sa assistant",
    guidanceLabel: "Ano ang dapat itanong ng assistant?",
    guidanceHint: "Isinulat mo at binalot bilang system guidance; hindi ito mababago ng mga kliyente. {{count}} sa {{max}} karakter.",
    guidanceSafety: "Ang nakalista lang dito at sa mga field ang itatanong ng assistant. Hindi ito kailanman nangangako ng warranty cover at hindi humihingi ng ID number o health data.",
    unsaved: "Mga hindi pa na-save na pagbabago",
    unsavedText: "May mga hindi ka pang na-save na pagbabago",
    discard: "Itapon",
    save: "I-save ang mga pagbabago",
    saved: "Na-save ang uri ng ticket.",
    notFoundTitle: "Walang ganitong uri ng ticket",
    notFoundBody: "Maaaring nabura na ito. Pumili ng uri mula sa Service settings.",
    errors: {
      nameRequired: "Pangalanan ang uri.",
      nameShort: "Gumamit ng hindi bababa sa {{min}} karakter.",
      nameLong: "Gumamit ng {{max}} karakter o mas kaunti.",
      nameFil: "Kailangan ng {{min}} hanggang {{max}} karakter ang pangalang Filipino, o iwanang walang laman.",
      descriptionLong: "Gumamit ng {{max}} karakter o mas kaunti.",
      guidanceLong: "Gumamit ng {{max}} karakter o mas kaunti.",
    },
  },
  fieldDrawer: {
    addTitle: "Magdagdag ng field",
    editTitle: "I-edit ang field: {{name}}",
    hint: "Ibinabahagi ang field sa lahat ng uring gumagamit nito; para sa uring ito lang ang mga setting sa ibaba.",
    mode: "Saan galing ang field",
    modeExisting: "Umiiral na field",
    modeNew: "Bagong field",
    existing: "Field",
    existingHint: "Mga field na nai-define na ng workspace mo at wala pa sa uring ito.",
    noneAvailable: "Nasa uring ito na ang bawat field na na-define mo. Gumawa ng bago.",
    forType: "Para sa uring ito",
    visible: "Nakikita ng mga kliyente ang field na ito",
    visibleHint: "Para sa staff lang ang mga nakatagong field.",
    editable: "Puwedeng i-edit ng mga kliyente",
    editableHint: "Lumalabas sa form na pinupunan ng kliyente, hindi lang sa ticket nila.",
    required: "Kailangang punan ng mga kliyente",
    requiredHint: "Hindi maipapadala ang ticket kung wala ito.",
    staff: "Kailangang punan ng staff",
    staffHint: "Hindi makakausad ang staff hangga't walang value.",
    staffOptions: { none: "Hindi kailangan", create: "Kapag ginawa ang ticket", resolve: "Bago i-resolve ang ticket" },
    condition: "Ipakita lang kapag…",
    conditionHint: "Puwedeng dropdown o oo/hindi na field ng uring ito ang magulang.",
    conditionNone: "Magdagdag muna ng dropdown o oo/hindi na field sa uring ito.",
    conditionAlways: "Laging ipakita",
    conditionValues: "…ay isa sa",
    add: "Idagdag ang field",
    save: "I-save ang field",
    added: "Naidagdag ang {{name}} sa uring ito.",
    updated: "Na-update ang {{name}}.",
    errors: {
      clientFlags: "Dapat nakikita ng mga kliyente ang field bago nila ito ma-edit o kailanganing punan.",
      conditionValues: "Lagyan ng tsek ang kahit isang value na nagpapakita sa field na ito.",
      conditionMany: "Gumamit ng 20 value o mas kaunti.",
    },
  },
  fieldTypes: {
    text: { name: "Maikling teksto", hint: "Isang linya, hanggang 500 karakter." },
    long_text: { name: "Mahabang teksto", hint: "Maraming linya, hanggang 5,000 karakter." },
    number: { name: "Numero", hint: "Anumang numero, may opsyonal na saklaw." },
    integer: { name: "Buong numero", hint: "Isang bilang; walang decimal." },
    bool: { name: "Oo / hindi", hint: "Iisang pagpili sa pagitan ng dalawang sagot." },
    date: { name: "Petsa", hint: "Isang petsa sa kalendaryo." },
    datetime: { name: "Petsa at oras", hint: "Petsa na may oras ng araw." },
    dropdown: { name: "Dropdown", hint: "Isang pagpili mula sa listahan mo." },
    multi_select: { name: "Multi-select", hint: "Ilang pagpili mula sa listahan mo." },
    asset: { name: "Kagamitan", hint: "Pumipili ng isa sa mga record ng kagamitan ng kliyente." },
    site: { name: "Site", hint: "Pumipili ng isa sa mga site ng kliyente." },
    order: { name: "Order", hint: "Pumipili ng isa sa mga order ng kliyente." },
    contact: { name: "Contact", hint: "Pumipili ng katrabaho sa organisasyon ng kliyente." },
    files: { name: "Mga file", hint: "Mga larawan, video o dokumento." },
    serial: { name: "Serial number", hint: "Teksto na may format hint sa ilalim ng kahon." },
  },
  fieldForm: {
    label: "Label",
    key: "Key",
    keyHint: "snake_case, hanggang {{max}} karakter. Hindi na ito nagbabago pagkatapos gawin ang field.",
    keyLocked_one: "Hindi nagbabago ang key at ang uri. {{count}} uri ng ticket ang gumagamit sa field na ito.",
    keyLocked_other: "Hindi nagbabago ang key at ang uri. {{count}} uri ng ticket ang gumagamit sa field na ito.",
    type: "Uri",
    options: "Mga opsyon",
    optionsHint: "Isa bawat linya: English, o English | Filipino. Hindi mawawala ang mga nai-save nang sagot kapag pinalitan ang pangalan ng opsyon.",
    help: "Help text (English)",
    helpFil: "Help text (Filipino)",
    bounds: {
      min: "Pinakamaliit na value",
      max: "Pinakamalaking value",
      maxLength: "Pinakamahabang sagot (karakter)",
      maxFiles: "Pinakamaraming file",
      maxSelected: "Pinakamaraming pagpili",
      formatHint: "Format hint",
    },
    ai: "Puwedeng punan ng assistant mula sa chat",
    aiHint: "Hinahayaan ang intake assistant na magmungkahi ng value mula sa isinulat ng kliyente.",
    pii: "May personal na data",
    piiHint: "Ibinubura sa mga log at export.",
    hiddenAi: "Huwag ipadala ang value sa AI",
    hiddenAiHint: "Para sa mga panloob na halaga tulad ng gastos. Pinipigilan din nito ang assistant na punan ito.",
    errors: {
      keyRequired: "Maglagay ng key.",
      keyShape: "Gumamit ng snake_case: maliliit na letra, numero at underscore, nagsisimula sa letra, hanggang {{max}} karakter.",
      keyTaken: "May field nang may ganitong key.",
      labelRequired: "Lagyan ng label ang field.",
      long: "Gumamit ng {{max}} karakter o mas kaunti.",
      number: "Maglagay ng numero.",
      whole: "Maglagay ng buong numero.",
      positive: "Maglagay ng numerong 1 pataas.",
      range: "Hindi dapat mas maliit sa pinakamaliit ang pinakamalaking value.",
      between: "Maglagay ng buong numero mula {{min}} hanggang {{max}}.",
      optionsFew: "Magdagdag ng hindi bababa sa dalawang opsyon.",
      optionsMany: "Gumamit ng {{max}} opsyon o mas kaunti.",
      optionsRepeat: "Dapat magkakaiba ang bawat opsyon.",
      optionsValue: "Hindi magawang naka-save na value ang isang opsyon. Gumamit ng letra o numero sa pangalan nito.",
    },
  },
  fields: {
    note: "Sa mga uri ng ticket ang mga field. Buuin at ayusin ang mga ito sa type editor; dito mo sila dine-define nang isang beses para sa lahat ng uri.",
    openTypes: "Buksan ang mga uri ng ticket",
    title: "Mga field",
    objectLabel: "Mga field ng",
    objects: { ticket: "Mga ticket", organisation: "Mga organisasyon", contact: "Mga contact" },
    new: "Bagong field",
    newTitle: "Bagong field",
    editTitle: "I-edit ang field",
    dialogHint: "I-define kung ano ang field. Sa type editor itatakda kung paano ito ginagamit ng uri (pagkakasunod, sino ang nakakakita, mga kondisyon).",
    create: "Gumawa ng field",
    save: "I-save ang field",
    created: "Nagawa ang {{name}}.",
    updated: "Na-update ang {{name}}.",
    edit: "I-edit",
    editAria: "I-edit ang {{name}}",
    deleteAria: "Burahin ang {{name}}",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Hindi mabubura ang field na ginagamit pa ng uri ng ticket, live na workflow o naka-save na sagot: alisin ito sa mga uri ng ticket sa halip, para manatiling nababasa ang mga sagot.",
    deleteConfirm: "Burahin ang field",
    deleted: "Nabura ang {{name}}.",
    emptyTitle: "Wala pang field dito",
    emptyBody: {
      ticket: "Kinokolekta ng mga field ang mga detalyeng kailangan ng ticket. Gumawa ng isa, saka idagdag sa isang uri ng ticket.",
      organisation: "Hawak ng mga field ng organisasyon ang sinusubaybayan mo sa bawat kumpanyang kliyente, tulad ng account tier o numero ng kontrata.",
      contact: "Hawak ng mga field ng contact ang sinusubaybayan mo sa bawat tao, tulad ng departamento o paboritong branch.",
    },
    moreOptions: "+{{count}} pa",
    usedBy_one: "Ginagamit ng {{count}} uri ng ticket.",
    usedBy_other: "Ginagamit ng {{count}} uri ng ticket.",
    usedByRecords: "Ipinapakita sa mismong record.",
    footPlain: "Mga field na na-define: {{count}}.",
    footLimited: "Mga field na na-define: {{count}} sa {{limit}} sa planong {{plan}}.",
    footUnlimited: "Mga field na na-define: {{count}}. Walang limit sa planong {{plan}}.",
    footNote: "Magkakasama ang bilang ng mga field ng ticket, organisasyon at contact.",
  },
  codes: {
    title: "Mga resolution code",
    intro: "Pumipili ng isa ang staff kapag nilutas o kinansela ang ticket. Hindi kailanman nagpapadala ng satisfaction survey ang code na nilalaktawan ang CSAT.",
    new: "Bagong code",
    newTitle: "Bagong resolution code",
    editTitle: "I-edit ang resolution code",
    label: "Label",
    key: "Key",
    keyHint: "Hinango sa English na label; maliliit na letra, numero at underscore. Hindi ito nagbabago.",
    keyLocked: "Hindi nagbabago ang key.",
    usable: "Magagamit ito ng staff kapag ang ticket ay",
    category: { resolved: "Nalutas", closed: "Sarado o kinansela" },
    skipsCsat: "Laktawan ang CSAT survey",
    skipsCsatHint: "Para sa mga kinalabasang hindi naranasan ng kliyente, tulad ng duplicate at spam.",
    create: "Gumawa ng code",
    save: "I-save ang code",
    created: "Nagawa ang {{name}}.",
    updated: "Na-update ang {{name}}.",
    builtIn: "Built-in",
    noCsat: "Walang CSAT survey",
    uses_one: "{{count}} ticket ang nagtatapos dito",
    uses_other: "{{count}} ticket ang nagtatapos dito",
    activeAria: "Ginagamit ang {{name}}",
    edit: "I-edit",
    editAria: "I-edit ang {{name}}",
    deleteAria: "Burahin ang {{name}}",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Hindi mabubura ang code na pinagtatapusan ng mga ticket: i-off na lang ito.",
    deleteConfirm: "Burahin ang code",
    deleted: "Nabura ang {{name}}.",
    emptyTitle: "Walang resolution code",
    emptyBody: "Kailangan ng staff ng kahit isang code para malutas ang ticket. Gawin ang una.",
    errorTitle: "Hindi nag-load ang mga resolution code",
    errors: {
      labelRequired: "Lagyan ng label ang code.",
      keyShape: "Gumamit ng maliliit na letra, numero at underscore, nagsisimula sa letra.",
      keyTaken: "May code nang may ganitong key.",
      categories: "Pumili ng kahit isang sitwasyon.",
    },
  },
  statuses: {
    title: "Mga status",
    new: "Bagong status",
    builtIn: "Built-in",
    custom: "Custom",
    default: "Default ng kategorya nito",
    pauses: "Pina-pause ang resolution clock",
    notSelectable: "Lampas sa plano mo: pinananatili para sa mga kasalukuyang ticket",
    clientEn: "Kliyente (English):",
    clientFil: "Kliyente (Filipino):",
    uses_one: "{{count}} ticket ang nasa status na ito",
    uses_other: "{{count}} ticket ang nasa status na ito",
    notify: "Abisuhan ang kliyente",
    notifyAria: "Abisuhan ang kliyente kapag pumasok sa {{name}} ang ticket",
    edit: "I-edit",
    editAria: "I-edit ang {{name}}",
    deleteAria: "Burahin ang {{name}}",
    deleteTitle: "Burahin ang {{name}}?",
    deleteUnused: "Walang ticket sa status na ito, kaya agad itong mabubura.",
    deleteUsed_one: "{{count}} ticket ang nasa status na ito. Lilipat ito sa status na pipiliin mo sa ibaba.",
    deleteUsed_other: "{{count}} ticket ang nasa status na ito. Lilipat ang mga ito sa status na pipiliin mo sa ibaba.",
    replacement: "Ilipat ang mga ticket nito sa",
    replacementHint: "Mga status lang na kapareho ng kategorya ang iniaalok.",
    replacementChoose: "Pumili ng status",
    replacementRequired: "Pumili ng status na paglilipatan ng mga ticket nito.",
    deleteConfirm: "Burahin ang status",
    deleted: "Nabura ang {{name}}.",
    created: "Nagawa ang {{name}}.",
    updated: "Na-update ang {{name}}.",
    emptyTitle: "Walang status",
    emptyBody: "May mga built-in na status ang bawat workspace. I-reload ang pahina; kung walang laman pa rin, makipag-ugnayan sa support.",
    footPlain: "Mga custom na status: {{count}}.",
    footLimited: "Mga custom na status: {{count}} sa {{limit}} sa planong {{plan}}.",
    footUnlimited: "Mga custom na status: {{count}}. Walang limit sa planong {{plan}}.",
    footNote: "Laging Action needed ang ipinapakita sa mga kliyente para sa Waiting for client.",
    categoriesTitle: "Paano kumikilos ang mga kategorya",
    behaviour: {
      new: "walang nakatalaga, naghihintay na kunin.",
      open: "ginagawan ng aksyon; tumatakbo ang mga SLA clock.",
      pending: "naghihintay sa kliyente; nagpa-pause ang mga SLA clock at nagsisimula ang mga paalala.",
      on_hold: "naghihintay sa ikatlong partido; puwedeng mag-pause ang resolution.",
      resolved: "naayos na, kinukumpirma ng kliyente; kusang nagsasara pagkalipas ng ilang araw.",
      closed: "tapos na; basahin lang.",
    },
  },
  statusForm: {
    newTitle: "Bagong status",
    editTitle: "I-edit ang status",
    hint: "Nakapirmi ang anim na kategorya at sila ang may dalang pag-uugali. Ikaw ang pipili ng mga salita, kulay at kung sino ang aabisuhan.",
    staff: "Label para sa staff",
    client: "Label para sa kliyente",
    category: "Kategorya",
    categoryLocked: "Hindi mababago ang kategorya ng built-in na status, o ng status na ginagamit.",
    colour: "Kulay",
    colourHint: "Lilim lang ang nagbabago; mananatili ang icon ng kategorya.",
    colourDefault: "Default ng kategorya",
    colours: { neutral: "Neutral", info: "Asul", primary: "Brand", accent: "Amber", success: "Berde", warning: "Kahel", danger: "Pula" },
    preview: "Preview",
    previewSample: "Status",
    notify: "Abisuhan ang kliyente kapag pumasok sa status na ito ang ticket",
    notifyHint: "Ipinapadala sa kliyente ang e-mail para sa status na ito.",
    pause: "I-pause ang resolution clock",
    pauseHint: "Para sa mga status na naghihintay sa ikatlong partido.",
    makeDefault: "Gawing default ng kategorya nito",
    makeDefaultHint: "Dito mapupunta ang mga ticket na inilipat sa kategoryang ito.",
    create: "Gumawa ng status",
    save: "I-save ang status",
    errors: {
      staffRequired: "Ilagay ang label para sa staff.",
      clientRequired: "Ilagay ang nakikita ng kliyente.",
      long: "Gumamit ng {{max}} karakter o mas kaunti.",
    },
  },
  preview: {
    title: "Live preview",
    kind: "Uri ng preview",
    widget: "Form ng widget",
    ai: "Buod ng AI",
    staff: "View ng staff",
    widgetLabel: "Preview ng form ng widget",
    aiLabel: "Preview ng card ng buod ng AI",
    staffLabel: "Preview ng view ng staff",
    report: "Mag-ulat ng problema: {{type}}",
    choose: "Pumili…",
    addFile: "Magdagdag ng larawan o video",
    submit: "Ipadala",
    edit: "I-edit",
    onlyPreview: "Preview lang: walang ipinapadala.",
    noFields: "Walang field na ipinapakita sa mga kliyente.",
    widgetHint: "Pumili ng value sa dropdown o oo/hindi na field para makita ang paglabas ng mga kondisyonal na field.",
    readOnly_one: "{{count}} pang field ang lalabas sa pahina ng ticket ng kliyente kapag napunan ng staff.",
    readOnly_other: "{{count}} pang field ang lalabas sa pahina ng ticket ng kliyente kapag napunan ng staff.",
    aiTitle: "Ito ang naintindihan ko",
    aiHint: "Pareho ng mga field at kondisyon ng form. Sample na chat ang mga value.",
    filledByAi: "Pinunan ng assistant",
    neverSent: "Hindi kailanman ipinapadala sa assistant",
    staffOnly: "Staff lang: hindi itinatanong",
    ask: "Itanong sa kliyente",
    askRequired: "Itanong sa kliyente (kailangan)",
    staffTitle: "Panel ng mga field sa ticket",
    staffHint: "Hinaharang ng Required to resolve ang Resolve dialog hangga't hindi napupunan ang field.",
    staffOnlyChip: "Staff lang",
    requiredToResolve: "Kailangan bago i-resolve",
    samples: {
      asset: "Sample na kagamitan · SN-0001",
      site: "Sample na site · Pangunahing gusali",
      order: "Sample na order · ORD-1001",
      contact: "Sample na katrabaho",
    },
    sampleValues: {
      text: "Sample na teksto",
      long_text: "Maikling paglalarawan ng nangyari",
      number: "12.5",
      integer: "3",
      bool: "Oo",
      date: "Sample na petsa",
      datetime: "Sample na petsa at oras",
      dropdown: "Unang opsyon",
      multi_select: "Unang opsyon",
      asset: "Sample na kagamitan",
      site: "Sample na site",
      order: "Sample na order",
      contact: "Sample na katrabaho",
      files: "1 larawan",
      serial: "SN-0001",
    },
  },
} as const;
